import vnActiveLogin from "./main.vue";
import Vue from 'vue'
import BsGetCid from "../BsGetCid";
let root = null;
function createComponent(component, props) {
    console.log(component)
    const conCtor = Vue.extend(component)
    const el = new conCtor({propsData: props}).$mount()
    document.body.appendChild(el.$el)
    el.remove = function () {
        document.body.removeChild(el.$el);
        el.$destroy();
        root = null;
    };
    return el
}

export default {
    vnLogin(props) {
        BsGetCid().then((res)=>{
            if (res.cid && res.access_token && !props.reset) {
                props.success && props.success({
                    cid: res.cid,
                    access_token: res.access_token
                })
            } else {
                props = Object.assign({isProtocol: true, reset: false}, props)
                if(root){
                    root.remove()
                }
                root = createComponent(vnActiveLogin, props)
                return root;
            }
        })
    }
}